import { offer as EnUsOffer } from '../en-us/offer';
import { AgResourceLanguage } from '../types';

export const offer: AgResourceLanguage['offer'] = {
  ...EnUsOffer,
  offerPrice: {
    firstTimePurchaseIncludes: 'Första köpet inkluderar:',
    free: 'Gratis',
    total: 'Totalt',
    valueOfOneTimePurchase: 'Värde vid engångsköp',
    firstMonthFree: 'Få en gratis månad med AG1 + ett gratis välkomstpaket',
    firstMonthFreeTag: 'Gratis första månaden'
  }
};
